import {useEffect, useState} from 'react';
import type {SwiperClass} from 'swiper/react';

export function useSlidesOverflow(swiper: SwiperClass): boolean {
  const [slidesOverflow, setSlidesOverflow] = useState(false);

  useEffect(() => {
    if (!swiper) {
      return;
    }

    const update = () => setSlidesOverflow(!swiper.isLocked);
    update();

    swiper.on('lock', update);
    swiper.on('unlock', update);

    return () => {
      swiper.off('lock', update);
      swiper.off('unlock', update);
    };
  }, [swiper]);

  return slidesOverflow;
}
